import { render, staticRenderFns } from "./ArticleSocialStep.vue?vue&type=template&id=3a7f73c8&"
import script from "./ArticleSocialStep.vue?vue&type=script&lang=js&"
export * from "./ArticleSocialStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports